import React, { useState, useEffect, useRef } from "react";
import {
  FaAddressBook,
  FaAward,
  FaClock,
  FaEnvelope,
  FaMobile,
  FaMoneyBillWave,
  FaSearchLocation,
} from "react-icons/fa";
import { FaLocationDot } from "react-icons/fa6";
import { MdViewTimeline } from "react-icons/md";
import "./Dropdown.css";
import { FiMenu } from "react-icons/fi";
import { useSelector } from "../../../components/hooks/hooks";
import Switch from "react-switch";
import { ToastContainer, toast } from "react-toastify";
import { backendApi } from "../../../api/apiService";
import { FaPencil } from "react-icons/fa6";

export default function ArchiveListTable({
  candidates,
  formatDateToCustomFormat,
  goToEditPage,
  candidateInterview,
  jobOpeningId,
  getShortList,
  getHiredList,
  getArchivedList,
  OnholdList,
  RejectList,
  RecruitList,
  StatusValues,
  userList,
  is_active
}) {
  const { HrmsFlag } = useSelector((state) => state.login);
  console.log(HrmsFlag, "userdata in shortData");

  const [showDropIndex, setShowDropIndex] = useState(null);
  const [showPopupStatus, setshowPopupStatus] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [Remarks, setRemarks] = useState("");
  const [toggleState, setToggleState] = useState(0);
  const [CandidateID, setCandidateID] = useState("");


  const refDrops = useRef([]);
  useEffect(() => {
    if (showDropIndex !== null) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showDropIndex]);

  const handleClickOutside = (event) => {
    if (refDrops.current.every(ref => ref && !ref.contains(event.target))) {
      setShowDropIndex(null);
    }
  };

  const toggleDropdown = (index) => {
    setShowDropIndex(showDropIndex === index ? null : index);
  };
  const handleToggle = (checked) => {
    setToggleState(checked ? 1 : 0);
  };
  const CandidateStatusEdit = (id) => {
    setshowPopupStatus(true);
    setCandidateID(id)
  };
  const CancelPopUp = () => {
    setshowPopupStatus(false);
    setSelectedStatus("");
    setRemarks("");
    setToggleState(0)
  };
  const handleStatusEdit = (event) => {
    setSelectedStatus(event.target.value);
  };
  const saveCandidateStatus = () => {
    if (selectedStatus === "") {
      toast.warn("Please select a status", { containerId: "Z" });
      return false;
    }
    var req = {
      functionName: "updateStatusCandiateShortList",
      sec_user_id: localStorage.getItem("userId"),
      candidate_id: CandidateID,
      job_opening_id: jobOpeningId,
      remarks: Remarks,
      category_type: selectedStatus,
      move_to_hrms: toggleState
    };
    backendApi(req).then((response) => {
      if (response.success === "1") {
        toast.success("Status Updated Succesfully", { containerId: "Z" });
        setshowPopupStatus(false)
        setSelectedStatus("");
        setRemarks("");
        setToggleState(0)
        getShortList();
        getHiredList();
        getArchivedList();
        OnholdList();
        RejectList();
        RecruitList();
      } else {
        console.error("Error");
        toast.error("Error", { containerId: "Z" });
        return false;
      }
    });
  };

  const [SelectedStatusData, setSelectedStatusData] = useState("")
  const [SelectedStatusId, setSelectedStatusId] = useState(null);
  const [ChangeStatusPopUp, setChangeStatusPopUp] = useState(false);
  const StatusPopUp = (id) => {
    console.log(id, "id of candidate");
    setChangeStatusPopUp(true)
    setCandidateID(id.candidate_id)
    const currentStatusName = getStatusName(id.rec_status_id);
    setSelectedStatusData(currentStatusName);
  }

  const handleStatusChange = (event) => {
    setSelectedStatusData(event.target.value);
    const selectedStatus = StatusValues.find(
      (status) => status.status_name === event.target.value
    );
    console.log("Selected selectedStatus:", selectedStatus);
    if (selectedStatus) {
      setSelectedStatusId(selectedStatus.id);
    }
  };
  const ClosePopUpStatus = () => {
    setChangeStatusPopUp(false)
  }



  //UPDATE CANDIDATE STATUS
  const UpdateCandidateStatus = () => {
    if (SelectedStatusData === "") {
      toast.warn("Please select a status", { containerId: "Z" });
      return false;
    }
    var req = {
      functionName: "changeStatusShortList",
      // sec_user_id: localStorage.getItem("userId"),
      candidate_id: CandidateID,
      job_opening_id: jobOpeningId,
      rec_status_id: SelectedStatusId,
      created_by: localStorage.getItem("userId"),

    };
    backendApi(req).then((response) => {
      if (response.success === "1") {
        toast.success("Status Updated Succesfully", { containerId: "Z" });
        setChangeStatusPopUp(false)
        setSelectedStatusData("");
        getHiredList();
        OnholdList();
        RejectList();
        RecruitList();
      } else {
        console.error("Error");
        toast.error("Error", { containerId: "Z" });
        return false;
      }
    });
  };
  const getStatusName = (rec_status_id) => {
    const matchingStatus = StatusValues.find(
      (status) => status.id === rec_status_id
    );
    return matchingStatus ? matchingStatus.status_name : "Status not found";
  };
  const currentUserId = localStorage.getItem('userId');
  const getUserRole = (userId) => {
    const user = userList.find(user => user.id === parseInt(userId, 10));
    return user ? user.role_name : null;
  };
  const currentUserRole = getUserRole(currentUserId);
  console.log(currentUserRole, "currentUserRole");



  return (
    <div className="table-scroll">
      {candidates.length > 0 ? (
        <table className="table-responsive">
          <thead style={{ height: "30px" }}>
            <tr>
              <th style={{ width: "20px" }}>#</th>
              <th style={{ textAlign: "left", width: "250px" }}>
                Candidate Details
              </th>
              <th style={{ textAlign: "left", width: "450px" }}>Skill Set</th>
              <th style={{ textAlign: "left", width: "150px" }}>Experience</th>
              <th style={{ textAlign: "left", width: "200px" }}>Status</th>
              <th style={{ textAlign: "left", width: "200px" }}>Actions</th>
            </tr>
          </thead>
          {candidates?.map((candidateData, index) => {
            return (
              <tbody>
                <tr>
                  <td aria-label="Lead Summary">{index + 1}</td>
                  <td aria-label="Lead Summary">
                    <p className="schedule-td-head">
                      {candidateData.full_name}
                    </p>
                    <div class="mb-2">
                      <span class="label-text"> <FaAddressBook title="address" size={12} className="me-1" /></span>
                      <span className="font-Medium ">{candidateData.address ? candidateData.address : "NA"}</span>
                    </div>
                    <div class="mb-2">
                      <span class="label-text"> <FaEnvelope title="email" size={12} className="me-1" /></span>
                      <span className="font-Medium ">{candidateData.email_id ? candidateData.email_id : "NA"}</span>
                    </div>
                    <div class="mb-2">
                      <span class="label-text"> <FaMobile title="Contact No" size={12} className="me-1" /></span>
                      <span className="font-Medium ">
                        {candidateData.mobile_no
                          ? candidateData.mobile_no
                          : "NA"}
                      </span>
                    </div>
                    <div class="mb-2">
                      <span class="label-text"> <FaSearchLocation title="location" size={12} className="me-1" /></span>
                      <span className="font-Medium ">
                        {candidateData.location ? candidateData.location : "NA"}
                      </span>
                    </div>
                    <div class="mb-2">
                      <span class="label-text"> <FaClock title="Uploaded On" size={12} className="me-1" /></span>
                      <span className="font-Medium ">
                        {formatDateToCustomFormat(
                          candidateData.candidate_created_date
                        )}
                      </span>
                    </div>
                  </td>
                  {/* <td aria-label="Skills" style={{ textAlign: "left" }}>
                    <span className="">
                      <p className="mx-0 mb-1 lead-name">
                        <span
                          style={{
                            width: "100%",
                            display: 'flex',
                            flexDirection: 'column'
                          }}
                        >
                          {candidateData.candidate_skill_set ? (
                            candidateData.candidate_skill_set
                              .split(",")
                              .map((loc, i) => (
                                <span
                                  key={i}
                                  style={{
                                    fontSize: 10.5,
                                    backgroundColor: "#fdf498",
                                    borderRadius: "5px",
                                    margin: "0 5px 5px 0",
                                    padding: "2px 5px",
                                    color: "#000",
                                  }}
                                >
                                  {loc.trim()}
                                </span>
                              ))
                          ) : (
                            <span style={{ fontSize: 12 }}>NA</span>
                          )}
                        </span>
                      </p>
                    </span>
                  </td> */}
                  <td aria-label="Skills" style={{ textAlign: "left" }}>
                    {candidateData.candidate_skill_set ? (
                      candidateData.candidate_skill_set.split(",").map((loc, i) => (
                        <span className="skill-span me-1" key={i}>
                          {loc.trim()}
                        </span>
                      ))
                    ) : (
                      <span style={{ fontSize: 12 }}>NA</span>
                    )}
                  </td>
                  <td>
                    <div class="mb-2">
                      <span class="label-text"> <FaAward title="experience" size={12} className="me-1" /></span>
                      <span className="font-Medium ">
                        {candidateData.total_experiance}
                      </span>
                    </div>
                    <div class="mb-2">
                      <span class="label-text"> <FaMoneyBillWave title="CTC" size={12} className="me-1" /></span>
                      <span className="font-Medium ">
                        {candidateData.ctc ? candidateData.ctc : "NA"}
                      </span>
                    </div>
                    <div class="mb-2">
                      <span class="label-text"> <MdViewTimeline title="CTC" size={12} className="me-1" /></span>
                      <span className="font-Medium ">
                        {candidateData.notice_period
                          ? candidateData.notice_period
                          : "NA"}
                      </span>
                    </div>
                    <div class="mb-2">
                      <span class="label-text"> <FaLocationDot title="CTC" size={12} className="me-1" /></span>
                      <span className="font-Medium ">
                        {candidateData.preferredLocation
                          ? candidateData.preferredLocation
                          : "NA"}
                      </span>
                    </div>
                  </td>
                  <td>
                    {currentUserRole !== "Recruiter" &&
                      currentUserRole !== 'Executive' ? (
                      <div className="d-flex align-items-center gap-3 mb-2">
                        <p>Status: {getStatusName(candidateData.rec_status_id)}</p>
                        <FaPencil
                          style={{ color: 'red' }}
                          onClick={() => StatusPopUp(candidateData)}
                        />
                      </div>
                    ) : null}

                    <div><span>Updated By {candidateData.rec_status_by}</span></div>
                    <div><span>On {new Date(candidateData.res_status_date).toLocaleDateString()}</span></div>
                    <br></br>

                    <span>
                      <span className="shortlist-name">Archived By</span>{" "}<br></br>
                      {candidateData.shortlisted_by}
                    </span>
                  </td>
                  {/* <td aria-label="View" style={{ textAlign: "center" }}>
                    <div className="mt-1">
                      <button
                        className="btn-btn btn btn-btn2"
                        onClick={() => goToEditPage(candidateData.candidate_id)}
                      >
                        Edit
                      </button>
                    </div>
                    <div className="mt-1">
                      <button
                        className="btn-btn btn btn-btn1"
                        onClick={() =>
                          candidateInterview(candidateData.candidate_id)
                        }
                      >
                        Schedule
                      </button>
                    </div>
                  </td> */}
                  <td aria-label="View" style={{ textAlign: "center" }}>
                    <div className="mt-1 position-relative">
                      <FiMenu onClick={() => toggleDropdown(index)} size={24} />
                      <div
                        ref={el => refDrops.current[index] = el}
                        className={`dropdown-card ${showDropIndex === index ? "show" : ""}`}
                      >
                        <ul>
                          <li onClick={() => goToEditPage(candidateData.candidate_id)}>Edit</li>
                          <li onClick={() =>
                            candidateInterview(candidateData.candidate_id)
                          }>Schedule</li>
                          <li onClick={() => CandidateStatusEdit(candidateData.candidate_id)}>Move Position</li>

                        </ul>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            );
          })}
        </table>
      ) : (
        <span
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <h4 className="errorMsg">No Candidates archived</h4>{" "}
        </span>
      )}
      {showPopupStatus && (
        <div
          className="modal_parent"
          id="deletesprint"
        >
          <div className="module_popup deletePeople">
            <div className="module_innerpopup module_bodypop">
              <div className="module_headdiv">
                <h4 className="popup_head"> Change Status</h4>
              </div>
              <div className="form-row">
                <label htmlFor="" className="form-label">
                  Status <span className="red ml-1">*</span>
                </label>
                <select
                  className="form-control"
                  name="status"
                  value={selectedStatus}
                  onChange={handleStatusEdit}
                >
                  <option value="">-Select-</option>
                  <option value="Archived">Archived</option>
                  <option value="Hired">Hired</option>
                </select>

                <div class="form-group">
                  <label for="" class="form-label">Remarks </label>
                  <textarea type="text" value={Remarks} onChange={(e) => setRemarks(e.target.value)} class="form-control" placeholder="Enter Remarks..." name="Remark"></textarea>
                </div>
              </div>
              <div className="mt-2 d-flex align-items-center flex-wrap gap-3 justify-content-between">
                {HrmsFlag === 1 && selectedStatus === "Hired" && (
                  <div className="d-flex flex-column align-items-start">
                    <small>Move to HRMS</small>
                    <Switch
                      className="switch_case"
                      handleDiameter={16}
                      height={18}
                      width={40}
                      checked={toggleState === 1}
                      onChange={handleToggle}
                    />
                  </div>
                )}
                <div className="d-flex gap-3">
                  <button
                    type="submit"
                    className="btn btn-btn1 btn-btn"
                    onClick={saveCandidateStatus}
                    disabled={is_active === 0}
                  >
                    Update
                  </button>
                  <button
                    type="button"
                    className="btn btn-btn2 btn-btn"
                    onClick={() => CancelPopUp()}
                  >
                    Cancel
                  </button>
                </div>
              </div>

            </div>
          </div>
        </div>
      )}

      {ChangeStatusPopUp && (
        <div
          className="modal_parent"
          id="deletesprint"
        >
          <div className="module_popup deletePeople">
            <div className="module_innerpopup module_bodypop">
              <div className="module_headdiv">
                <h4 className="popup_head"> Change Status</h4>
              </div>
              <div className="form-row">
                <label htmlFor="" className="form-label">
                  Status <span className="red ml-1">*</span>
                </label>
                <select
                  className="form-control"
                  name="status"
                  value={SelectedStatusData}
                  onChange={handleStatusChange}
                >
                  <option value="">-Select-</option>
                  {StatusValues.filter((status) => status.is_default === 1).map((status) => (
                    <option key={status.id} value={status.status_name}>
                      {status.status_name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="mt-2 d-flex align-items-center flex-wrap gap-3 justify-content-between">
                <div className="d-flex gap-3">
                  <button
                    type="submit"
                    className="btn btn-btn1 btn-btn"
                    onClick={UpdateCandidateStatus}
                    disabled={is_active === 0}
                  >
                    Update
                  </button>
                  <button
                    type="button"
                    className="btn btn-btn2 btn-btn"
                    onClick={ClosePopUpStatus}
                  >
                    Cancel
                  </button>
                </div>
              </div>

            </div>
          </div>
        </div>
      )}


    </div>
  );
}
